// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"filter_wrapper__3eEnC","label":"filter_label__1dmFO","input":"filter_input__rKdir","search":"filter_search__2Mw-R","buttonWrapper":"filter_buttonWrapper__16-E3"};